<div class="institution_data" [formGroup]="instituicaoForm" style="font-size: 0.86em;">
  <div style="display: flex; align-items: center; gap: 15px; margin-bottom: 10px;">
    <p class="section-title" style="margin: 0;"><strong>{{ 'instituicao' | translate }}</strong></p>
    <label *ngIf="!isValid()" style="cursor: pointer; display: flex; align-items: center; justify-content: flex-start; font-weight: bold; color: #4caf50; font-size: 0.85em;">
      <input type="checkbox" tabindex="-1" style="transform: scale(1); cursor: pointer; width: auto; margin: 0 6px 0 2px;" [checked]="isInstituicaoVerificadaChecked" (change)="onInstituicaoValidadoChange($event)" /> {{ 'Instituição não encontrada na pesquisa.' | translate }}
    </label>
  </div>

  <div class="institution_data__itens" style="display: flex; flex-direction: column; gap: 4px; width: 100%;">
    <!-- Campos de Extração -->
    <!-- Nome (Linha Única) -->
    <div style="display: flex; width: 100%;">
      <div style="flex: 1;">
        <label><strong>{{ 'Nome' | translate }}:</strong></label>
        <input type="text" formControlName="nomeInstituicao" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'nomeInstituicao' | translate }}" readonly />
      </div>
    </div>

    <div style="display: flex; gap: 4px; width: 100%;">
      <div style="flex: 1;">
        <label><strong>{{ 'Rua' | translate }}:</strong></label>
        <input type="text" formControlName="rua" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'rua' | translate }}" readonly />
      </div>
      <div style="flex: 1;">
        <label><strong>{{ 'Cidade' | translate }}:</strong></label>
        <input type="text" formControlName="localidade" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'localidade' | translate }}" readonly />
      </div>
    </div>

    <div style="display: flex; gap: 4px; width: 100%;">
      <div style="flex: 1;">
        <label><strong>{{ 'CEP' | translate }}:</strong></label>
        <input type="text" formControlName="codigoPostal" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'codigoPostal' | translate }}" readonly />
      </div>
      <div style="flex: 1;">
        <label><strong>{{ 'Cód. Cidade' | translate }}:</strong></label>
        <input type="text" formControlName="cdgCiudad" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'Cód. Cidade' | translate }}" readonly />
      </div>
    </div>

    <div style="display: flex; gap: 4px; width: 100%;">
      <div style="flex: 1;">
        <label><strong>{{ 'E-mail' | translate }}:</strong></label>
        <input type="email" formControlName="email" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'E-mail' | translate }}" readonly />
      </div>
      <div style="flex: 1;">
        <label><strong>{{ 'Número Instituição' | translate }}:</strong></label>
        <input type="text" formControlName="nro_instit" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'Número Instituição' | translate }}" readonly />
      </div>
    </div>

    <!-- Telefones -->
    <div style="display: flex; gap: 4px; width: 100%; flex-wrap: wrap;">
      <div style="flex: 1; display: flex; align-items: flex-end; gap: 4px; min-width: 45%;" *ngFor="let tel of telefoneArray.controls; let j = index">
        <div style="flex: 1;">
          <label><strong>{{ 'telefone' | translate }} {{ j + 1 }}:</strong></label>
          <input [formControl]="tel" class="institution-input" style="width: 100%; box-sizing: border-box;" placeholder="{{ 'telefone' | translate }}" readonly />
        </div>
        <!-- <button type="button" class="addRemoveButton" style="margin-bottom: 2px;" (click)="removeTelefone(j)" *ngIf="j >= 1">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#999999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="8" y1="12" x2="16" y2="12"></line>
          </svg>
        </button> -->
      </div>
    </div>

  <div class="flex gap-1 status-row" [ngClass]="getInstStatusClass()" *ngIf="getInstStatus()"
    style="margin-top: 10px; padding: 10px; border-radius: 4px; align-items: flex-start; border-left: 6px solid; width: 94%;"
    [style.background-color]="getInstStatus() === 'Válido' ? '#eafbe7' : getInstStatus() === 'Ambíguo' ? '#fffde7' : '#fdeaea'"
    [style.border-left-color]="getInstStatus() === 'Válido' ? '#4caf50' : getInstStatus() === 'Ambíguo' ? '#ffeb3b' : '#e53935'">
    <span class="status-text" style="min-width: 80px;font-weight: bold; margin-bottom: 6px;">{{ getInstStatus() }}</span>

    <!-- Bloco de Retorno da Base de Dados -->

      <!-- Nome Instituição (Retorno) -->
      <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px; flex: 1;">
           <ng-container *ngIf="isAmbiguous() && !isInstituicaoInsercaoManualAtiva">
            <div style="grid-column: span 2; display: flex; width: 100%;">
              <select class="institution-input font-bold review-input"
                      [class.field-incomplete]="mostrarPendencias && !campoValido"
                      style="flex: 1; width: auto; background: inherit;"
                      (change)="onInstitutionSelect($event)">
                <option value="">{{ 'Selecionar' | translate }}...</option>
                <option *ngFor="let inst of ConteudoInst; let i = index" [value]="i">
                  {{ inst.nombre_institucion }}
                </option>
              </select>
              <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalInstituicao()" [title]="'Pesquisar instituição' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              </button>
              <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="ativarEntradaManualInstituicao()" [title]="'Inserir manualmente' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4Z"></path></svg>
              </button>
            </div>
          </ng-container>
          <ng-container *ngIf="(!isAmbiguous() && !isNotFound()) || (isAmbiguous() && isInstituicaoInsercaoManualAtiva)">
            <div style="grid-column: span 2; display: flex; width: 100%;">
              <input type="text" #retornoNomeInput formControlName="retorno_nome" class="review-input" [class.field-incomplete]="mostrarPendencias && !campoValido" style="flex: 1; width: auto; background: inherit;" [placeholder]="'Nome' | translate" (keydown.space)="abrirModalInstituicaoSpace($event)" (input)="onRetornoNomeInput()" />
              <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalInstituicao()" [title]="'Pesquisar instituição' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              </button>
            </div>
          </ng-container>
          
          <ng-container *ngIf="isNotFound()">
            <div style="grid-column: span 2; display: flex; width: 100%;">
              <input type="text" formControlName="retorno_nome" class="review-input" [class.field-incomplete]="mostrarPendencias && !campoValido" style="flex: 1; width: auto; background: inherit;" [placeholder]="'Nome' | translate" (keydown.space)="abrirModalInstituicaoSpace($event)" (input)="onRetornoNomeInput()" />
              <button type="button" class="btn btn-primary" style="margin-left: 5px; padding: 2px 8px;" (click)="abrirModalInstituicao()" [title]="'Pesquisar instituição' | translate">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              </button>
            </div>
          </ng-container>

          <input type="text" 
                 formControlName="retorno_rua"
                 class="review-input" 
                 style="width: 95%; background: inherit;" [placeholder]="'Rua' | translate" />
          <input type="text" 
                 formControlName="retorno_cidade"
                 class="review-input" 
                 style="width: 95%; background: inherit;" [placeholder]="'Cidade' | translate" />
          <input type="text" 
                 formControlName="retorno_cep"
                 class="review-input" 
                 style="width: 95%; background: inherit;" [placeholder]="'CEP' | translate" />
          <input type="text"
                 formControlName="retorno_cdg_cidade"
                 class="review-input"
                 style="width: 95%; background: inherit;" [placeholder]="'Cód. Cidade' | translate" />
          <input type="text"
                 formControlName="retorno_nro_instit"
                 class="review-input"
                 style="width: 95%; background: inherit;" [placeholder]="'Número Instituição' | translate" />
      </div>
    </div>
  </div>
</div>

<!-- Modal de Pesquisa de Instituição -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isSearchModalOpen">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Pesquisar instituição por similaridade' | translate}}</h5>
        <button type="button" class="close" aria-label="Close" (click)="fecharModalInstituicao()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="flex form filtros">
          <div class="form-group filtro" style="width: 100%;">
            <label>{{ 'Instituição Selecionada:' | translate}} <strong>{{ instituicaoForm.get('nomeInstituicao')?.value || 'Nenhuma' }}</strong> </label>
            <label>{{ 'Cód. Cidade:' | translate}} <strong>{{ instituicaoForm.get('cdgCiudad')?.value || 'Nenhum' }}</strong></label>
            <input type="text" class="form-control" [(ngModel)]="pesquisaInstituicao" (input)="filtrarInstituicoes()" (keydown.shift.o)="openCombo($event)" (keydown.enter)="confirmarSelecaoCombo($event)" (keydown.ArrowDown)="openCombo($event)" [placeholder]="'Pesquisar instituição...' | translate" [ngModelOptions]="{standalone: true}">
            <small style="color: #666; font-size: 11px; display: block; margin-top: 4px;">{{ 'Pressione Shift + O ou a Seta para Baixo para abrir a lista' | translate }}</small>
            <small style="color: #666; font-size: 11px; display: block; margin-top: 2px;">{{ 'Use Alt + Número para selecionar rapidamente' | translate }}</small>
          </div>
        </div>

        <div class="flex form filtros" *ngIf="listaInstituicoesFiltrada && listaInstituicoesFiltrada.length > 0" style="margin-top: 15px;">
          <div class="form-group filtro" style="width: 100%;">
            <select class="form-control" size="12" [(ngModel)]="instituicaoSelecionadaCombobox" [ngModelOptions]="{standalone: true}" (click)="onInstituicaoClick($event)" (keydown.enter)="confirmarSelecaoCombo($event)" (keydown.ArrowDown)="openCombo($event)">
              <option value="" disabled selected>{{ 'Selecione uma instituição da lista...' | translate }}</option>
              <option *ngFor="let inst of listaInstituicoesFiltrada; let i = index" [value]="i">{{ i }} - {{ inst.instituicao }}<ng-container *ngIf="!inst.isNotFoundItem"> - {{ inst.cidade }} - {{ inst.nro_instit }}</ng-container></option>
            </select>
          </div>
        </div>
        <div *ngIf="listaInstituicoesFiltrada?.length === 0" class="text-center" style="color: #999; padding: 10px; margin-top: 15px;">
          {{ 'Nenhuma instituição encontrada.' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>